<template>
	<div ref="formElement">
		<suspense :timeout="0">
			<the-form-content
				:form-element="formElement"
				:lang="lang"
				:minisite-category-id="minisiteCategoryId"
				:minisite-id="minisiteId"
				:images-path="imagesPath"
				:cover-image="coverImage"
			/>
			<template #fallback>
				<div class="flex flex-col gap-6">
					<div>
						<n-skeleton text size="large" class="w-3/4" />
						<n-skeleton text />
						<n-skeleton text class="w-1/2" />
					</div>
					<div class="grid grid-cols-2 gap-4">
						<n-skeleton :repeat="5" size="large" class="w-full" />
					</div>
					<div class="flex justify-end">
						<n-skeleton size="large" class="w-1/4" />
					</div>
				</div>
			</template>
		</suspense>
	</div>
</template>

<script setup>
	import {NSkeleton} from 'naive-ui'
	import TheFormContent from './TheFormContent.vue'
	import {ref, toRefs} from 'vue'

	const props = defineProps({
		minisite: Object,
		lang: String,
	})
	const {minisite, lang} = toRefs(props)

	const {
		id: minisiteId,
		category: {id: minisiteCategoryId},
		imagesPath,
		coverImage,
	} = minisite.value

	const formElement = ref(null)
</script>
